export const BASE_URL = "https://pixel-backend.azurewebsites.net/api";

export const WS_URL = "wss://pixel-backend.azurewebsites.net/ws";

export const firebaseConfig = {
  apiKey: "AIzaSyDeF_HtQABSY6W_qC-pUf0HqhDksG20DRE",
  authDomain: "pixelperfect-ai.firebaseapp.com",
  databaseURL: "https://pixelperfect-ai-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "pixelperfect-ai",
  storageBucket: "pixelperfect-ai.appspot.com",
  messagingSenderId: "797238970822",
  appId: "1:797238970822:web:6f1b210beba4f0f2da4ac7",
  measurementId: "G-T350N2QN39",
};
